import { render, staticRenderFns } from "./teenagerHabit.vue?vue&type=template&id=1bc13c24&scoped=true&"
import script from "./teenagerHabit.vue?vue&type=script&lang=js&"
export * from "./teenagerHabit.vue?vue&type=script&lang=js&"
import style0 from "./teenagerHabit.vue?vue&type=style&index=0&id=1bc13c24&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc13c24",
  null
  
)

export default component.exports